import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetInventorySubTypesInputDto, InventorySubTypeCreateDto, InventorySubTypeDto, InventorySubTypeExcelDownloadDto, InventorySubTypeUpdateDto } from '../dtos/inventory-sub-type/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class InventorySubTypeService {
  private restService = inject(RestService);
  apiName = 'Planning';
  

  create = (input: InventorySubTypeCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, InventorySubTypeDto>({
      method: 'POST',
      url: '/api/planning/inventorySubTypes',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/planning/inventorySubTypes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/planning/inventorySubTypes',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, InventorySubTypeDto>({
      method: 'GET',
      url: `/api/planning/inventorySubTypes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/planning/inventorySubTypes/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetInventorySubTypesInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<InventorySubTypeDto>>({
      method: 'GET',
      url: '/api/planning/inventorySubTypes',
      params: { name: input.name, code: input.code, inventoryTypeId: input.inventoryTypeId, inventoryTypeName: input.inventoryTypeName, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: InventorySubTypeExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/planning/inventorySubTypes/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, code: input.code, inventoryTypeId: input.inventoryTypeId, inventoryTypeName: input.inventoryTypeName, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, InventorySubTypeDto[]>({
      method: 'GET',
      url: '/api/planning/inventorySubTypes/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: InventorySubTypeUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, InventorySubTypeDto>({
      method: 'PUT',
      url: `/api/planning/inventorySubTypes/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}